import Vue from 'vue'
const examination={
    state:{
        reservationInfo:[],
        // 已预约患者信息
        subscribedList:[]
    },
    mutations:{
        saveExaminationInfo(state,payload){
            state.reservationInfo=(state.reservationInfo).concat(payload);
        },
        resetExaminationInfo(state,payload){
            state.reservationInfo.length=0;
        },
        removeExaminationInfo(state,payload){
            state.reservationInfo= state.reservationInfo.filter(e=>e.CardId!=payload)
        },
        updateSubscribed(state,payload){
            state.subscribedList=payload
        },
        resetSubscribed(state,payload){
            state.subscribedList.length=0
        }
    }
};
export default examination



// WEBPACK FOOTER //
// ./src/store/modules/examination.js